"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.stats.total': 'Totale Onboarding',
    'onboarding.stats.in_progress': 'In Corso',
    'onboarding.stats.completed': 'Completati',
    'onboarding.stats.avatars_created': 'Avatar Creati',
};
